import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from './Component';
/**
 * The look-controls component:
 *
 * - Rotates the entity when we rotate a VR head-mounted display (HMD).
 * - Rotates the entity when we move the mouse.
 * - Rotates the entity when we touch-drag the touchscreen.
 *
 * @see https://aframe.io/docs/1.3.0/components/look-controls.html
 */

export var LookControls = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LookControls, _Component);

  function LookControls() {
    return _Component.apply(this, arguments) || this;
  }

  return LookControls;
}(Component);